export function scrollToElement($element, duration = 400) {
    if ($element.length === 0) {
        console.warn("Couldn't scroll to element, empty set", $element);
        return;
    }
    let offset = $element.offset().top;

    if (!$element.is(".scroll-target")) {
        offset -= $("header").outerHeight() + $("header").position().top + 20;
    }

    $("html,body").stop().animate({scrollTop: offset}, duration);
}
